module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2 mt-3"
  }, [_c('master-lists-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-582f513a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/MasterLists/index.vue
// module id = 2137
// module chunks = 0